import SvgInset from '@/components/SvgInset';
import { CDN_URL_ICONS } from '@/configs';

export default function IcFrens() {
  return <SvgInset size={16} svgUrl={`${CDN_URL_ICONS}/ic-frens.svg`} />;
}
